import { Injectable } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { Shipment } from '../../../models/shipment';
import { Observable } from 'rxjs';
import { emptyShipment } from '../../../constants/empty-shipment';
import { ShipmentService } from '../../../data/shipment.service';
import { selectNewShipmentTemplate } from '../../../store/profile/profile.state';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { ShipmentTemplate } from '../../../models/shipment-template';
import { ActionService } from './action.service';
import { ActionEnum } from '../../../enum/action.enum';
import { ActionStatusEnum } from '../../../enum/action-status.enum';

@Injectable({
    providedIn: 'root'
})
export class NewShipmentService {

    constructor(private store: Store<AppState>, private shipments: ShipmentService, private actionService: ActionService) {
    }

    private static fromTemplate(template: ShipmentTemplate): Shipment {
        return {
            ...emptyShipment,
            id: null,
            number: null,
            quote: null,
            shipper: template.shipper,
            destination: template.destination,
            broker: template.broker,
            soldTo: template.soldTo,
            courierOptions: template.courierOptions,
            courierForms: template.courierForms,
            signatureOption: template.signatureOption,
            packagingType: template.packagingType,
            documentsOnly: template.documentsOnly,
            currency: template.currency,
            weightUnit: template.weightUnit,
            dimensionUnit: template.dimensionUnit,
            paymentOption: template.paymentOption,
            paymentAccountNumber: template.paymentAccountNumber,
            notifyShipper: template.notifyShipper,
            notifyDestination: template.notifyDestination
        };
    }

    create(): Observable<Shipment> {
        return this.actionService.sync(ActionEnum.SHIPMENT_CREATE).pipe(
            filter((action) => action.status === ActionStatusEnum.COMPLETED),
            map((action) => (action.output['0'] as any).shipment),
            tap((shipment) => this.shipments.addOneToCache(shipment))
        );
    }
}
